export default __webpack_public_path__ + "static/storage-2-05465a47d30114bbe609b92acea09b2a.png";